import styled from 'styled-components';

export const StyledLeadGuaranteeBanner = styled.div`
    margin-top: 20px;
`;
